import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/components/dialogue/radix-dialog";
import PerformanceGoal from "./performance-goal";

const GoalViewDialog = ({
  open,
  close,
  employeeId,
}: {
  open: boolean;
  close: () => void;
  employeeId: number;
}) => {
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="bg-white/50 backdrop-blur-lg rounded-xl max-w-6xl w-full">
        <DialogHeader>
          <DialogTitle>Performance</DialogTitle>
        </DialogHeader>
        <div>
          <PerformanceGoal employeeId={employeeId} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GoalViewDialog;
